module.exports = __webpack_public_path__ + "r-v3/img/ml_49_00.96dc9a06.jpg";